import React, { useState } from 'react';
import EmptyState from './EmptyState';
import ProcessingStatus from './ProcessingStatus';
import DocumentAccessControl from './DocumentAccessControl';
import ChatWindow from './ChatWindow';
import UserSettings from './UserSettings';
import useDocumentStore from '../stores/documentStore';
import './MainContent.css';

function MainContent({ error, activeDocumentId, documentResult, handleDocumentClick, isPublicView, showSettings, onCloseSettings }) {
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const isUploading = useDocumentStore(state => state.isUploading);

  const handleChatToggle = () => {
    setIsChatOpen(!isChatOpen);
  };

  const renderChatButton = () => {
    if (isPublicView) {
      return null;
    }
    
    return (
      <button 
        className="chat-button" 
        onClick={handleChatToggle}
        aria-label="Открыть чат"
      >
        Вопросы по документу
      </button>
    );
  };

  return (
    <div className="maincontent__container">
      {error && <div className="maincontent__error">{error}</div>}
      
      {showSettings ? (
        <UserSettings onClose={onCloseSettings} />
      ) : !activeDocumentId && !isUploading ? (
        <EmptyState />
      ) : (
        <>
          {!isPublicView && activeDocumentId && <DocumentAccessControl documentId={activeDocumentId} />}
          <ProcessingStatus 
            documentResult={documentResult} 
            activeDocumentId={activeDocumentId}
            handleDocumentClick={handleDocumentClick}
          />
          {!isUploading && activeDocumentId && renderChatButton()}
          {isChatOpen && <ChatWindow onClose={handleChatToggle} documentId={activeDocumentId} />}
        </>
      )}
    </div>
  );
}

export default MainContent;
